import { PaymentElement } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import ReactiveButton from "reactive-button";
import { RiseLoader } from "react-spinners";
import { FaPlusCircle } from "react-icons/fa";
import { toast } from "wc-toast";

const button_color = '#F7941D'

const override = `
display: block;
margin: 0 auto;
border-color: red;
alignSelf:center
`;

export default function CheckoutForm(props) {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);

    async function trying(e) {
        if (props.check) {
            setLoading(true)

            if (!stripe || !elements) return;

            const { error, paymentIntent } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: `${window.location.origin}/`,
                },
                redirect: "if_required",
            });

            if (error) {
                console.log('Error', error)
                props.done(false)
            } else if (paymentIntent.status === "succeeded") {
                setMessage("Payment status: " + paymentIntent);
                console.log('Payemnt ', paymentIntent)
                props.done(true)
            } else {
                setMessage("Unexpected state");
                props.done(false)
            }

            setLoading(false)
        }
        else toast('You must need to agree to our Terms and Conditions')

    }


    const [loading, setLoading] = useState(false)


    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <form id="payment-form">

                <PaymentElement id="payment-element" />

                {loading ? <div style={{ alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', width: 80, height: 60, marginLeft: '40%' }}>
                    <RiseLoader color={button_color} isLoading={true}
                        css={override} size={20} />
                </div> : <div style={{ alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', width: 20, height: 20 }}>

                </div>}

                <div style={{ width: 400, display: 'flex', alignSelf: 'center', justifyContent: 'center', alignItems: 'center', marginBottom: 15, marginTop: 15 }}>
                    <div onClick={() => { trying() }} style={{ cursor: 'pointer', width: 200, alignSelf: 'center', marginTop: 15, marginBottom: 5, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 48, backgroundColor: '#F7941D', borderRadius: 26,marginLeft:50 }}>
                        <text style={{ fontFamily: 'Poppins', fontWeight: 'bold', fontSize: 18, color: 'white', fontFamily: 'Montserrat', textAlign: 'center' }}>{props.text}</text>
              
                    </div>
                </div>
                {/* Show any error or success messages */}
                {message && <div id="payment-message"></div>}
            </form>
        </div>
    );
}